module.exports = __webpack_public_path__ + "static/machine-installation-3-e06ca550f657b1e610f83d1f17cdacaf.jpg";